module.exports = __webpack_public_path__ + "./img/categories.svg";